/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelBrkQualItem.ts                   *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/brk-qual-item";

export class AutogenModelBrkQualItem<RowType extends ModelRow> extends Endpoint<RowType, RowBrkQualItemFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowBrkQualItem extends ModelRow<RowBrkQualItemFields> {
	constructor(values?: Partial<RowBrkQualItemFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowBrkQualItemFields {
	company_id: string;
	comparison_type: string;
	custom: string;
	descr: string;
	field_name: string;
	id: string;
	is_active: string;
	table_name: string;
}

